import React, { useMemo } from 'react';
import { GoalSectionItemCard } from 'shared/components/ui/goal-section-item-card';
import {
  SortableContainer,
  SortableContainerProps,
} from 'shared/components/ui/sortable-container';
import { DraggableOptions } from 'shared/types/draggable-types';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';

export type GoalSectionCardProps = Omit<
  React.ComponentProps<typeof GoalSectionItemCard>,
  'section' | 'goal'
> & {
  id: ID;
  goal: Goal;
  hasDnd?: boolean;
  preventDnd?: boolean;
  children?: React.ReactNode;
};

const allDraggableOptions = Object.values(DraggableOptions);

export const GoalSectionCard: React.FC<GoalSectionCardProps> = ({
  id,
  goal,
  hasDnd,
  preventDnd,
  children,
  ...rest
}) => {
  const section = useMemo(
    () => goal?.sections?.find((section) => section.id === id),
    [goal?.sections, id],
  );

  if (!goal || !section) {
    return null;
  }

  const Container = hasDnd ? SortableContainer : React.Fragment;
  const containerProps = (
    hasDnd
      ? {
          id: section.id,
          type: DraggableOptions.GoalSection,
          cantInteractWithTypes: preventDnd
            ? allDraggableOptions
            : [DraggableOptions.LifeArea, DraggableOptions.Goal],
        }
      : {}
  ) as SortableContainerProps;

  return (
    <Container {...containerProps}>
      <GoalSectionItemCard section={section} goal={goal} {...rest} />
      {children}
    </Container>
  );
};
